class ScrollLock {
  private small = false
  private max = false
  private locked = false
  private top = 0
  private left = 0

  constructor() {
    window.addEventListener('scroll', () => this.updateSmall())
    document.body.style.overflow = ''
    this.updateSmall()
  }

  setMax(value: boolean) {
    this.max = value
    this.update()
  }

  private updateSmall() {
    const width = document.documentElement.clientWidth
    this.small = width < 480
    this.update()
  }

  private update() {
    const lock = this.max && this.small
    if (this.locked === lock) return
    this.locked = lock

    if (lock) {
      this.top = document.documentElement.scrollTop
      this.left = document.documentElement.scrollLeft
      document.body.style.overflow = 'hidden'
      document.body.scrollTop = this.top
      document.body.scrollLeft = this.left
    } else {
      document.body.style.overflow = ''
      document.documentElement.scrollTop = this.top
      document.documentElement.scrollLeft = this.left
    }
  }
}

export const scrollLock = new ScrollLock()
